import clsx from 'clsx';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';
import { useToast } from '../toast/ToastContext';

interface Props {
  text: string;
  tooltipText?: string;
  copiedMessage?: string;
  iconSize?: string;
}

export default function CopyTextButton({ text, tooltipText, copiedMessage, iconSize }: Props) {
  const intl = useIntl();
  const { setToast } = useToast();

  return (
    <>
      <CopyToClipboard
        text={text}
        onCopy={() => {
          setToast({
            show: true,
            type: 'Primary',
            header: intl.formatMessage({ id: 'MESSAGE.COPIED' }),
            message: copiedMessage ?? 'Link copied',
          });
        }}
      >
        <i
          className={clsx(
            'far fa-clone mx-2 cursor-pointer align-middle d-print-none',
            iconSize ? `fs-${iconSize}` : 'fs-1x'
          )}
          title={tooltipText ?? 'Copy Link'}
        />
      </CopyToClipboard>
    </>
  );
}
